import logger from 'helpers/logger';
import { queryCmsContent } from './_api';

export interface NavigationAdapterRequestInterface {
	preview: boolean;
	previewData: Content.PreviewData;
}

export interface NavigationAdapterResponseInterface {
	properties: Record<string, unknown>;
	children: Array<NavigationAdapterResponseInterface>;
	id: number;
	culture: string;
	name: string;
	url: string;
	documentType: string;
	template: string;
	createDate: string;
	sortOrder: number;
}

// Function to transform JSON to a more friendly structure
// Basically this just replaces children with descendants
// but could completely transform the JSON if desired
const transform = (item): Array<Navigation.NavigationItem> => {
	if (!item || !Array.isArray(item)) {
		return [];
	}

	return item
		.filter((child) => child != null)
		.map((child) => {
			return {
				id: child.id || 0,
				name: child.name || '',
				url: child.url || '',
				hidden: Boolean(child.hidden),
				title: child.title || child.name || '',
				descendants: child.children === null ? [] : transform(child.children || []),
			};
		});
};

export const getCmsNavigation = async ({ preview, previewData }: NavigationAdapterRequestInterface): Promise<Navigation.NavigationItem> => {
	const path = '/';
	const method = 'POST';
	const query = `{
        navigation: navigation(path: "${path}" maxDepth: 5 includeHidden : true)
    }`;

	const profiler = logger.startTimer();

	try {
		const content = await queryCmsContent({ method, query, preview, previewData });

		if (!content?.navigation) {
			logger.warn('No navigation data received from CMS');
			return {
				id: 0,
				name: 'Root',
				url: '/',
				hidden: false,
				title: 'Navigation Root',
				descendants: [],
			};
		}

		const navigationArray = transform([content.navigation]);
		const transformedData: Navigation.NavigationItem = navigationArray[0] || {
			id: 0,
			name: 'Root',
			url: '/',
			hidden: false,
			title: 'Navigation Root',
			descendants: [],
		};

		return transformedData;
	} catch (error) {
		logger.error('Navigation transformation failed', { error: error.message });
		return {
			id: 0,
			name: 'Root',
			url: '/',
			hidden: false,
			title: 'Navigation Root',
			descendants: [],
		};
	} finally {
		profiler.done({ message: 'getNavigation', level: 'debug' });
	}
};
